// Landing template
import LandingPageTemplate from './templates/LandingPageTemplate.tsx';

export default LandingPageTemplate;
